
import React, { PureComponent } from 'react';
import BesoinsItem from "./besoinsItem";
import { connect } from 'react-redux';
import { selectedServices } from '../../../actions/action';
import CONSTANTS from '../../../constants';
import "./besoinsDetails.css";
import BasketImage from '../../../images/AP/basket-icon.png';

const mapStateToProps = state => state;
const mapDispatchToProps = { selectedServices };

class BesoinsDetails extends PureComponent {
  static defaultProps = {
    className: "",
  };
  constructor(props) {
    super(props);
    this.state = {
      isBlockfull: false,
    };
  }

  render() {
    const isBlockfull = this.props.store.SelectedServices.length;
    if (isBlockfull) {
      return (
        <div className={`services-details`}>
          <div className="services-details__wrapper">
            {this.props.store.SelectedServices.map(function (family, key) {
              return <BesoinsItem
                      forfaits={family}
                      imageUrl={family.Image}
                      label={family.interventionLabel}
                      id={family.interventionId}
                      zindex={key}
                      key={'besoins' + family.interventionId} />;
              }.bind(this))}

          </div>
        </div>
      );
    }
    else
      return (
        <div className={`services-details isEmpty`}>
          <div className="empty-message">
            <img src={BasketImage} />
            <p>{CONSTANTS.LABELS.needs_basket_empty}</p>
          </div>
        </div>
      );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(BesoinsDetails);
